import { useState, type ReactNode } from "react";

interface CollapsibleSectionProps {
  id: string;
  title: string;
  titleExtra?: ReactNode;
  count?: number;
  defaultOpen?: boolean;
  forceOpen?: boolean;
  variant?: "panel" | "section" | "sidebar";
  hint?: string;
  children: ReactNode;
}

export function CollapsibleSection({
  id,
  title,
  titleExtra,
  count,
  defaultOpen = true,
  forceOpen = false,
  variant = "section",
  hint,
  children,
}: CollapsibleSectionProps) {
  const [open, setOpen] = useState(defaultOpen);
  const summaryId = `${id}-summary`;
  const isOpen = forceOpen || open;

  return (
    <details
      id={id}
      className={`cd-collapse cd-collapse--${variant}`}
      open={isOpen}
      onToggle={(e) => {
        if (!forceOpen) setOpen(e.currentTarget.open);
      }}
      aria-labelledby={summaryId}
    >
      <summary id={summaryId} className="cd-collapse__summary">
        <span className="cd-collapse__chevron" aria-hidden />
        <span className="cd-collapse__title-group">
          <span className="cd-collapse__title">{title}</span>
          {titleExtra}
        </span>
        {count !== undefined && count > 0 && (
          <span className="cd-collapse__count">{count}</span>
        )}
        {hint && <span className="cd-collapse__hint">{hint}</span>}
      </summary>
      <div className="cd-collapse__content">{children}</div>
    </details>
  );
}
